import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { GoMoon } from "react-icons/go";
import { MdOutlineWbSunny } from "react-icons/md";

export default function Navbar(props) {
    return (
        <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">{props.title}</Link>
                <div className=" " id="navbarSupportedContent">
                    <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
                        {
                            props.mode === 'light' ? < GoMoon onClick={props.toggleMode}  style={{cursor: "pointer", width: "20px", height: "20px"}}/> : < MdOutlineWbSunny onClick={props.toggleMode}  style={{cursor: "pointer", width: "20px", height: "20px"}}/>
                        }
                    </div>
                </div>
            </div>
        </nav>
    )
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    aboutText: PropTypes.string.isRequired
}

Navbar.defaultProps = {
    title: 'Set title here',
    aboutText: 'About'
  };